"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectRestaurantMap = void 0;
const React = require("react");
const react_1 = require("react");
const useRequiredContext_1 = require("../../../../../hooks/useRequiredContext");
const context_1 = require("../../handlers/CustomerLocationHandler/context");
const RetailLocationsContext_1 = require("../../contexts/RetailLocationsContext");
const GoogleMaps_1 = require("../../../../../components/base/atoms/GoogleMaps");
const useConfig_1 = require("../../../../../hooks/useConfig");
const constants_1 = require("../../helpers/constants");
const SelectRestaurantMap = ({ restaurants, mapId, mapHeight, onRestaurantMarkerClick, onRestaurantMarkerHover, onRestaurantMarkerLeave }) => {
    const { googleApiKey, googleMapStyleId } = (0, useConfig_1.useConfig)();
    const { customerLocation } = (0, useRequiredContext_1.useRequiredContext)(context_1.CustomerLocationContext);
    const { retailLocation } = (0, useRequiredContext_1.useRequiredContext)(RetailLocationsContext_1.RetailLocationsContext);
    const [mapMarkers, setMapMarkers] = (0, react_1.useState)(null);
    const markers = (0, react_1.useMemo)(() => {
        var _a;
        if (!customerLocation || !((_a = window.google) === null || _a === void 0 ? void 0 : _a.maps)) {
            return null;
        }
        const currentPositionMarker = [
            {
                title: "Current Position",
                position: customerLocation,
                clickable: false
            }
        ];
        if (!restaurants) {
            return currentPositionMarker;
        }
        const restaurantMarkers = restaurants.map(restaurant => {
            const { retailLocationId, title, address: { lat, lng } } = restaurant;
            const isSelected = retailLocation && retailLocation.retailLocationId === retailLocationId;
            return {
                title,
                position: {
                    lat,
                    lng
                },
                icon: {
                    url: isSelected
                        ? constants_1.TRestaurantMapMarkers.Selected
                        : constants_1.TRestaurantMapMarkers.UnSelected,
                    scaledSize: new google.maps.Size(36, 50)
                },
                animation: isSelected ? google.maps.Animation.BOUNCE : null,
                clickable: true
            };
        });
        return currentPositionMarker.concat(restaurantMarkers);
    }, [customerLocation, restaurants]);
    const findSelectedRestaurant = (0, react_1.useCallback)((marker) => restaurants.find(restaurant => marker.getTitle() === restaurant.title), [restaurants]);
    const onMarkerHover = (0, react_1.useCallback)((marker, mapMarkers) => {
        const currentPositionMarker = mapMarkers.find(mapMarker => mapMarker.getTitle() === "Current Position");
        const isCurrentPositionMarker = currentPositionMarker === marker;
        if (isCurrentPositionMarker) {
            return;
        }
        const otherMarkers = mapMarkers.filter(otherMapMarker => marker !== otherMapMarker);
        const scaledSize = new google.maps.Size(36, 50);
        marker.setIcon({
            url: constants_1.TRestaurantMapMarkers.Selected,
            scaledSize
        });
        marker.setAnimation(google.maps.Animation.BOUNCE);
        otherMarkers.forEach(otherMarker => {
            if (otherMarker.getClickable()) {
                otherMarker.setIcon({
                    url: constants_1.TRestaurantMapMarkers.UnSelected,
                    scaledSize
                });
                otherMarker.setAnimation(null);
                const otherRestaurant = findSelectedRestaurant(otherMarker);
                if (!otherRestaurant) {
                    return;
                }
                typeof onRestaurantMarkerLeave === "function" &&
                    onRestaurantMarkerLeave(otherRestaurant);
            }
        });
    }, [mapMarkers, restaurants]);
    (0, react_1.useEffect)(() => {
        if (!retailLocation || !mapMarkers) {
            return;
        }
        const restaurantMarker = mapMarkers.find(mapMarker => mapMarker.getTitle() === retailLocation.title);
        if (!restaurantMarker) {
            return;
        }
        const map = restaurantMarker.getMap();
        map.setCenter(restaurantMarker.getPosition());
        onMarkerHover(restaurantMarker, mapMarkers);
    }, [retailLocation, mapMarkers]);
    return (React.createElement(GoogleMaps_1.GoogleMaps, { mapId: mapId, center: customerLocation, markers: markers, apiKey: googleApiKey, mapStyleId: googleMapStyleId, width: "100%", height: mapHeight, controls: {
            draggable: true,
            zoomControl: true,
            scrollwheel: true
        }, hideUI: true, onMarkerClick: (marker, mapMakers) => {
            onMarkerHover(marker, mapMakers);
            const map = marker.getMap();
            map.setCenter(marker.getPosition());
            const selectedRestaurant = findSelectedRestaurant(marker);
            if (!selectedRestaurant) {
                return;
            }
            typeof onRestaurantMarkerClick === "function" &&
                onRestaurantMarkerClick(selectedRestaurant);
        }, onMarkerHover: (marker, mapMakers) => {
            onMarkerHover(marker, mapMakers);
            const selectedRestaurant = findSelectedRestaurant(marker);
            if (!selectedRestaurant) {
                return;
            }
            typeof onRestaurantMarkerHover === "function" &&
                onRestaurantMarkerHover(selectedRestaurant);
        }, 
        // TODO: fix render update warning
        onMarkersCreated: setMapMarkers }));
};
exports.SelectRestaurantMap = SelectRestaurantMap;
//# sourceMappingURL=index.js.map